<template>
  <div>
    <a-card v-if="masterBilllist" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="订单号" style="margin-left: 39px">
                <a-input v-model.trim="queryParam.orderNo" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 30px">
                <a-select v-model="queryParam.installType" @change="installChange" :allowClear="true">
                  <a-select-option v-for="type in installTypes" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.orderType" :allowClear="true" @change="getorderStatus">
                  <a-select-option v-for="type in List" :title="type.typeName" :key="type.orderTypeId">{{
                    type.typeName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.orderStatus" :allowClear="true">
                  <a-select-option v-for="type in order_status" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="客户姓名" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.clientName" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="客户联系方式">
                <a-input v-model.trim="queryParam.clientPhone" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-row :gutter="24" style="margin-left: 0px">
                <a-form-item label="客户地址" style="margin-left: 26px">
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.clientProvince" @change="getselect" :allowClear="true">
                      <a-select-option v-for="type in selectAllProvince" :title="type.provinceName"
                        :key="type.provinceCode">{{ type.provinceName }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.clientCity" @change="getprovinceName" :allowClear="true">
                      <a-select-option v-for="type in selectCityName" :title="type.cityName" :key="type.cityCode">{{
                        type.cityName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.clientArea" :allowClear="true">
                      <a-select-option v-for="type in selectAreaName" :title="type.areaName" :key="type.areaCode">{{
                        type.areaName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="9" :sm="24">
                    <a-input v-model.trim="queryParam.clientAddr" />
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="师傅姓名" style="margin-left: 26px">
                <a-input v-model.trim="queryParam.masterName" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="师傅联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model.trim="queryParam.masterMobile" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="师傅类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.masterType" :allowClear="true">
                  <a-select-option v-for="type in worker_type" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="师傅结算方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="queryParam.settlementMethod" :allowClear="true">
                  <a-select-option v-for="type in master_settle_method" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="建单人" style="margin-left: 39px">
                <a-input v-model="queryParam.createUser" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单负责人" style="margin-left: 15px">
                <a-select v-model="queryParam.orderPrincipal" :allowClear="true">
                  <a-select-option v-for="type in findByDeptId" :title="type.userName" :key="type.userId">{{
                    type.userName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="师傅负责人" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 13px">
                <a-select v-model="queryParam.masterPrincipal" :allowClear="true">
                  <a-select-option v-for="type in masterPrincipal" :title="type.userName" :key="type.userId">{{
                    type.userName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="结算周期" style="margin-left: 30px">
                <a-select v-model="queryParam.settlementCycle" :allowClear="true">
                  <a-select-option v-for="type in settle_cycle" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <div v-if="Ifstatus">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="备注" style="margin-left: 55px">
                  <a-input v-model.trim="queryParam.remark" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="对账单" style="margin-left: 45px">
                  <a-select v-model="queryParam.statementFlag" :allowClear="true">
                    <a-select-option value="1" title="生成"> 生成 </a-select-option>
                    <a-select-option value="0" title="未生成"> 未生成 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="订单子状态" style="margin-left: 13px">
                  <a-select v-model="queryParam.orderSubStatus" :allowClear="true">
                    <a-select-option v-for="type in order_substate" :title="type.dictLabel" :key="type.dictValue">{{
                      type.dictLabel
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item label="对账单编号" style="margin-left: 15px">
                  <a-input v-model.trim="queryParam.statementNo" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="暂不结算" style="margin-left: 13px">
                  <a-select v-model="queryParam.isTemporarilySettle" :allowClear="true">
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option value="1">是</a-select-option>
                    <a-select-option value="0">否</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="建单时间" style="margin-left: 26px">
                  <a-range-picker v-model="createTime" style="width: 100%" :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                  }" format="YYYY-MM-DD HH:mm:ss" :placeholder="['开始时间', '结束时间']" @change="onChangecreateOrde" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="订单完成时间">
                  <a-range-picker v-model="completeTime" style="width: 100%" :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                  }" format="YYYY-MM-DD HH:mm:ss" :placeholder="['开始时间', '结束时间']" @change="onChangecompleteOrder" />
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <a-row>
            <a-col :span="1" :offset="11">
              <span v-if="Ifstatus == 0" style="cursor: pointer" @click="getMore"><a-icon type="down-circle"
                  theme="twoTone" style="fontsize: 24px" /></span>
              <span v-if="Ifstatus == 1" style="cursor: pointer" @click="hiddenMore"><a-icon type="up-circle"
                  theme="twoTone" style="fontsize: 24px" /></span>
            </a-col>
            <a-col :span="12" :style="{ textAlign: 'right' }">
              <a-button type="primary" htmlType="submit" @click="query">查询</a-button>
              <a-button style="margin-left: 8px" @click="empty()">清空</a-button>
              <a-button style="margin-left: 8px" type="primary" v-if="exportMasterBill" @click="exportEnt()">导出
                Excel</a-button>
            </a-col>
          </a-row>
          <a-divider />
          <div class="">
            <a-row>
              <a-col :span="18"></a-col>
              <a-col :span="6" :style="{ textAlign: 'right' }">
                <div style="margin-bottom: 16px; margin-right: 0px">
                  <a-button type="primary" style="margin-right: 0px" :loading="loading" v-if="generateMasterBill"
                    @click="gocustGeneratestate">
                    生成对账单
                  </a-button>
                  <template v-if="hasSelected">
                    {{ `选中 ${selectedRowKeys.length} 条对账单` }}
                  </template>
                </div>
              </a-col>
            </a-row>
          </div>
          <!--    生成对账单的按钮和方法-->

          <!--    表格内容-->
          <s-table :pagination="{
            pageSizeOptions: pageSizeOptions, showQuickJumper: true, 'show-total': total => `共计 ${total} 项条目`
          }" size="default" ref="table" rowKey="sourceId" :columns="columns" :data="loadData" bordered
            :scroll="{ x: 4000 }" :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
            <span slot="action" slot-scope="text, record" style="white-space: nowrap">
              <!--查看按钮-->
              <a v-if="seeMasterBill" @click="orderdetailsView(record.orderId)">查看</a>
              <a-divider type="vertical" v-if="remarkMasterBill" />
              <!--备注按钮-->
              <a v-if="remarkMasterBill" @click="remarkList(record)">备注</a>
              <a-divider type="vertical" v-if="generateMasterBill && record.statementFlagCode == 0" />
              <!--生成对账单按钮-->
              <a v-if="generateMasterBill && record.statementFlagCode == 0" @click="goEnterpriseOne(record)">生成对账单</a>
            </span>
            <span slot="remark" slot-scope="text, record">
              <span v-if="record.remark">
                <span v-for="tab in record.remark.split('/$/,')">
                  <span>
                    {{ tab }}
                  </span>
                  <br />
                </span>
              </span>
            </span>
            <span slot="orderNo" slot-scope="text, record">
              <a-popover title="订单备注">
                <template slot="content">
                  <span v-if="record.remark">
                    <span v-for="tab in record.remark.split('/$/,')"><span>{{ tab }}</span>
                      <br />
                    </span>
                  </span>
                </template>
                <a type="primary">
                  {{ record.orderNo }}
                </a>
              </a-popover>
            </span>
            <span slot="totalPrice" slot-scope="text, record">
              <a-popover title="企业费用明细">
                <template slot="content">
                  <div style="overflow-y: auto; max-height: 450px; padding-right: 20px" v-if="record.amountDetail">
                    <span v-for="tab in record.amountDetail.split('/$/')"><span>{{ tab }}</span>
                      <br />
                    </span>
                  </div>
                </template>
                <a type="primary">
                  {{ record.totalPrice }}
                </a>
              </a-popover>
            </span>
          </s-table>
        </a-form>
      </div>

      <a-modal title="备注" style="top: 20px" :width="900" v-model="remarkgenerateible" @ok="remarkconfirmOk">
        <a-form :form="form">
          <div>
            <a-form-item v-if="remarkrows.length > 0" :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注信息">
              <div v-for="type in remarkrows" :key="type.remarkId">
                <span style="margin: 0 30px"> {{ type.remark }}</span>
                <span style="margin: 0 10px"> {{ type.createBy }}</span>
                <span> {{ type.createTime }}</span>
              </div>
            </a-form-item>
          </div>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="新增备注">
            <a-input v-decorator="['remark']" />
          </a-form-item>
        </a-form>
      </a-modal>
      <a-modal title="备注" style="top: 20px" :width="900" v-model="remarkible" @ok="remarkconfirmOk">
        <a-form :form="form">
          <div>
            <a-form-item v-if="remarkrows.length > 0" :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注信息">
              <div v-for="type in remarkrows" :key="type.remarkId">
                <span style="margin: 0 30px"> {{ type.remark }}</span>
                <span style="margin: 0 10px"> {{ type.createBy }}</span>
                <span> {{ type.createTime }}</span>
              </div>
            </a-form-item>
          </div>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="新增备注">
            <a-input v-decorator="['remark']" />
          </a-form-item>
        </a-form>
      </a-modal>
      <!-- 使用弹框组件-->
      <a-modal :title="Toptitle" style="top: 20px" width="80%" v-model="generateible" footer="">
        <a-table size="default" rowKey="sourceId" :columns="generatecolumns" :dataSource="DataList" :scroll="{ x: 1300 }"
          bordered :pagination="false">
          <span slot="action" slot-scope="text, record" style="white-space: nowrap">
            <a @click="billingView(record)">查看</a>
            <a-divider type="vertical" />
            <a @click="modifyDefaultTemplate(record)">修改默认模板</a>
            <a-divider type="vertical" />
            <a @click="remarkList(record)">备注</a>
            <a-divider type="vertical" />
            <a @click="remove(record)">移除</a>
          </span>
        </a-table>
        <div style="margin-bottom: 16px">
          <a-button type="primary" @click="EnterpriseStatementConfirm()" :loading="loading"
            style="margin-right: 20px; margin-top: 20px">
            生成对账单
          </a-button>
          <a-button type="primary" @click="goEnterpriseBill()" :loading="loading"
            style="margin-right: 20px; margin-top: 20px">
            取消
          </a-button>
          <!--<a-button type="primary" @click=""  :loading="loading" >-->
          <!--修改默认模板-->
          <!--</a-button>-->
        </div>
      </a-modal>
      <a-modal title="查看账单信息" style="top: 20px" :width="1600" v-model="informationible" @click="clicInformationModal"
        footer="">
        <a-form :form="form">
          <a-table size="default" rowKey="sourceId" :columns="informationcolumns" :dataSource="billinglist" bordered
            :pagination="false" :scroll="{ x: 3000 }">
            <span slot="remark" slot-scope="text, record">
              <span v-if="record.remark">
                <span v-for="tab in record.remark.split('/$/,')">
                  <span>
                    {{ tab }}
                  </span>
                  <br />
                </span>
              </span>
            </span>
            <span slot="orderNo" slot-scope="text, record">
              <a @click="orderNodetailsView(record.orderId)">{{ record.orderNo }}</a>
            </span>
          </a-table>
        </a-form>
      </a-modal>
      <!--    移除对账单确定按钮-->
      <a-modal title="移除" style="top: 20px" :width="800" v-model="removeible" :confirmLoading="confirmLoading"
        @ok="confirmOk" @cancel="confirmCancel">
        <p>确定移除该条对账单吗？</p>
      </a-modal>
      <!--    生成对账单确定按钮-->
      <!--<a-modal-->
      <!--title="生成企业对账单"-->
      <!--v-model="Enterprisevisible"-->
      <!--@ok="EnterpriseOk"-->
      <!--:confirmLoading="confirmLoading"-->
      <!--@cancel="handleCancel"-->
      <!--cancelText="返回"-->
      <!--okText="确认且进入对账单"-->

      <!--&gt;-->
      <!--<p>对账单已生成，是否进入对账单列表？</p>-->
      <!--</a-modal>-->
      <modify-default-template-model ref="modify"></modify-default-template-model>
      <edit-order-model v-if="$store.state.user_type == 1" ref="editorder"></edit-order-model>
      <edit-order-model1 v-else ref="editorder"></edit-order-model1>
      <associated-order-model ref="associatedorder" @ok="updateFeedbacklist"></associated-order-model>
    </a-card>
    <no-authority v-else></no-authority>
  </div>
</template>
<script>
import NoAuthority from '../enterprise/NoAuthority'
import modifyDefaultTemplateModel from './modules/modifyDefaultTemplateModel.vue'
import { getTemplate } from '@/api/finance/customerSingle'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import moment from 'moment'
import associatedOrderModel from '@/views/order/modules/associatedOrderModel'
import { STable } from '@/components'
import {
  getList,
  getselectAllProvince,
  getselectCityName,
  getselectAreaName,
  getmarketPrincipal,
  getSelectBrand,
  getOrderDetail,
  getSelectModel,
  getfindByDeptId,
  getmasterPrincipal,
  getfinddictAll,
} from '@/api/order/orderList'
import { getSourceList, getEnterpriseList, getenterGenerateState, getexportList } from '@/api/finance/masterBill'
import { getremarkList, saveremarkList } from '@/api/finance/enterpriseBill'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'
export default {
  name: 'MasterBill',
  components: {
    STable,
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1'),
    modifyDefaultTemplateModel,
    associatedOrderModel,
    NoAuthority,
    // 注册弹框组件
    // CustomerModal
  },
  data() {
    return {
      // 设置分页器
      pageSizeOptions: ['10', '20', '30', '40', '50', '100'],
      DataList: [],
      Toptitle: '',
      Ifstatus: 0,
      generatecolumns: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center',
        },
        {
          title: '操作栏',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '师傅姓名',
          dataIndex: 'masterName',
          align: 'center',
        },
        {
          title: '师傅负责人',
          dataIndex: 'masterPrincipal',
          align: 'center',
        },
        {
          title: '订单总计',
          dataIndex: 'orderAmount',
          align: 'center',
        },
        {
          title: '账单截止日期',
          dataIndex: 'closingDate',
          align: 'center',
        },
        {
          title: '付款方式',
          dataIndex: 'payType',
          align: 'center',
        },
        {
          title: '提现方式',
          dataIndex: 'withdrawalMethod',
          align: 'center',
        },
        {
          title: '提现周期',
          dataIndex: 'withdrawalCycle',
          align: 'center',
        },
        {
          title: '备注',
          dataIndex: 'remark',
        },
      ],
      selectedRowKeys: [], // Check here to configure the default column
      selectedRow: [],
      worker_type: [],
      master_settle_method: [],
      settle_cycle: [],
      // 存选中的id
      orderIdArr: [],
      order_substate: [],
      loading: false,
      form: this.$form.createForm(this),
      // 查询参数
      queryParam: {},
      // 表头
      // 表头 MasterBill
      columns: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          align: 'center',
        },
        {
          title: '操作栏',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
        {
          title: '结算方式',
          dataIndex: 'settlementMethod',
          align: 'center',
        },
        {
          title: '结算周期',
          dataIndex: 'settlementCycle',
          align: 'center',
        },
        {
          title: '订单状态栏',
          dataIndex: 'orderStatus',
          align: 'center',
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          scopedSlots: { customRender: 'orderNo' },
          align: 'center',
        },
        {
          title: '师傅姓名',
          dataIndex: 'masterName',
          align: 'center',
        },
        {
          title: '师傅联系方式',
          dataIndex: 'masterMobile',
          align: 'center',
        },
        {
          title: '师傅类型',
          dataIndex: 'masterType',
          align: 'center',
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
        },
        {
          title: '数量',
          dataIndex: 'number',
          align: 'center',
        },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '订单完成时间',
          dataIndex: 'orderFinishTime',
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center',
        },
        {
          title: '联系方式',
          dataIndex: 'clientPhone',
          align: 'center',
        },
        {
          title: '客户地址',
          dataIndex: 'clientAddr',
          width: '300px',
        },
        {
          title: '订单总金额',
          dataIndex: 'totalPrice',
          scopedSlots: { customRender: 'totalPrice' },
          align: 'center',
        },
        {
          title: '基础费用',
          dataIndex: 'basePrice',
          align: 'center',
        },
        {
          title: '额外费用',
          dataIndex: 'otherPrice',
          align: 'center',
        },
        {
          title: '成本',
          dataIndex: 'cost',
          align: 'center',
        },
        {
          title: '师傅负责人',
          align: 'center',
          dataIndex: 'masterPrincipal',
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center',
        },
        {
          title: '订单子状态',
          dataIndex: 'orderSubStatus',
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
        },
        {
          title: '对账单',
          dataIndex: 'statementFlag',
          align: 'center',
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
          align: 'center',
        },
        {
          title: '建单人',
          dataIndex: 'createUser',
          align: 'center',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: '380px',

          scopedSlots: { customRender: 'remark' },
        },
      ],
      informationcolumns: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center',
        },
        {
          title: '结算方式',
          dataIndex: 'settlementMethod',
          align: 'center',
        },
        {
          title: '结算周期',
          dataIndex: 'settlementCycle',
          align: 'center',
        },
        {
          title: '订单状态栏',
          dataIndex: 'orderStatus',
          align: 'center',
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          scopedSlots: { customRender: 'orderNo' },
          align: 'center',
        },
        {
          title: '师傅姓名',
          dataIndex: 'masterName',
          align: 'center',
        },
        {
          title: '师傅联系方式',
          dataIndex: 'masterMobile',
          align: 'center',
        },
        {
          title: '师傅类型',
          dataIndex: 'masterType',
          align: 'center',
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
        },
        {
          title: '数量',
          dataIndex: 'number',
          align: 'center',
        },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '订单完成时间',
          dataIndex: 'orderFinishTime',
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center',
        },
        {
          title: '联系方式',
          dataIndex: 'clientPhone',
          align: 'center',
        },
        {
          title: '客户地址',
          dataIndex: 'clientAddr',
          width: '300px',
        },
        {
          title: '订单总金额',
          dataIndex: 'totalPrice',
          align: 'center',
        },
        {
          title: '基础费用',
          dataIndex: 'basePrice',
          align: 'center',
        },
        {
          title: '额外费用',
          dataIndex: 'otherPrice',
          align: 'center',
        },
        {
          title: '成本',
          align: 'cost',
        },
        {
          title: '师傅负责人',
          align: 'center',
          dataIndex: 'masterPrincipal',
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center',
        },
        {
          title: '订单子状态',
          dataIndex: 'orderSubStatus',
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
        },
        {
          title: '对账单',
          dataIndex: 'statementFlag',
          align: 'center',
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
          align: 'center',
        },
        {
          title: '建单人',
          dataIndex: 'createUser',
          align: 'center',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: '380px',

          scopedSlots: { customRender: 'remark' },
        },
      ],
      SourceList: [],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return getSourceList(Object.assign(parameter, this.queryParam))
      },
      data: [],
      // 省
      selectAllProvince: [],
      // 市
      selectCityName: [],
      List: [],
      // 区
      selectAreaName: [],
      masterPrincipal: [],
      findByDeptId: [],
      // 字典为是否
      restaurantTypes: [],
      // 字典为安装类型
      installTypes: [],
      // 字典为时间类型
      timetype: [],
      // 字典为订单状态类型
      order_status: [],
      generateMasterBill: checkPermission('GenerateMasterBill'),
      remarkMasterBill: checkPermission('remarkMasterBill'),
      exportMasterBill: checkPermission('exportMasterBill'),
      seeMasterBill: checkPermission('seeMasterBill'),
      masterBilllist: checkPermission('masterBill:query:list'),
      remarkrows: [],
      orderid: [],
      billinglist: [],
      billingrecord: '',
      remarkrecord: '',
      recordorderId: '',
      remarkible: false,
      remarkgenerateible: false,
      generateible: false,
      informationible: false,
      removeible: false,
      // Enterprisevisible:false,
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      completeTime: '',
      createTime: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
  },
  filters: {},
  // 下拉框的选项
  async created() {
    let dictTypes = [
      'install_type',
      'order_status',
      'cash_status',
      'order_substate',
      'cash_cycle',
      'sys_yes_no',
      'worker_type',
    ]
    getfinddictAll({ dictTypes: dictTypes.join() }).then((res) => {
      this.installTypes = res.install_type
      this.order_status = res.order_status
      this.order_substate = res.order_substate
      this.settle_cycle = res.cash_cycle
      this.worker_type = res.worker_type
      this.master_settle_method = res.cash_status
    })
    // 订单负责人
    this.masterPrincipal = []
    await getmasterPrincipal().then((res) => {
      this.masterPrincipal = res
    })
    // 订单负责人
    this.findByDeptId = []
    await getfindByDeptId().then((res) => {
      this.findByDeptId = res
    })
    await getselectAllProvince().then((res) => {
      if (res.code === 0) {
        this.selectAllProvince = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })
  },
  // 计算选中的数据条数
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0
    },
  },
  methods: {
    SetOptionTitle() {
      var selects = document.getElementsByTagName('select')
      if (selects.length > 0) {
        for (var i = 0; i < selects.length; i++) {
          var options = selects[i].options
          if (selects[i].options.length > 0) {
            for (var j = 0; j < options.length; j++) {
              if (options[j].title == '') options[j].title = options[j].text
            }
          }
        }
      }
    },
    query() {
      this.$refs.table.refresh(true)
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    empty() {
      this.queryParam = {}
      this.createTime = ''
      this.completeTime = ''
    },
    moment,
    getorderStatus(val) {
      if (val) {
        this.$set(this.queryParam, this.queryParam.orderType, val.value)
      } else {
        this.$set(this.queryParam, this.queryParam.orderType, '')
      }
    },
    // 修改默认模板
    modifyDefaultTemplate(record) {
      // console.log(record)
      getTemplate({ enterpriseId: record.enterpriseId }).then((res) => {
        if (res.code === 0) {
          console.log(res.data)
          this.$refs.modify.showmodify(res.data)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    exportEnt() {
      var str = process.env.VUE_APP_API_BASE_URL + '/finance/masterBill/export?pageNum=1&pageSize=10'
      for (let i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      window.open(str)
      // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      // var date = new Date()
      // var Y = date.getFullYear()
      // var M = ((date.getMonth() + 1) < 10) ? ('0' + (date.getMonth() + 1)) : ((date.getMonth() + 1))
      // var D = (date.getDate() < 10) ? ('0' + date.getDate()) : (date.getDate())
      // var h = (date.getHours() < 10) ? ('0' + date.getHours()) : (date.getHours())
      // var m = (date.getMinutes() < 10) ? ('0' + date.getMinutes()) : (date.getMinutes())
      // var s = (date.getSeconds() < 10) ? ('0' + date.getSeconds()) : (date.getSeconds())
      // var ms = ''
      // if (date.getMilliseconds() < 10) {
      //   ms = '00' + date.getMilliseconds()
      // } else if (date.getMilliseconds() < 100) {
      //   ms = '0' + date.getMilliseconds()
      // } else {
      //   ms = date.getMilliseconds()
      // }
      // parent.location.href = getVUE_APP_GATEWAR_BASE_URL1()+"/api/apartment/callManage/exportCallManage?"+'attendanceTimestr='+this.queryParam.attendanceTimestr+'&callType='+this.queryParam.callType+'&checkInStatus='+this.queryParam.checkInStatus+'&name='+this.queryParam.name
      // getexportList(this.queryParam).then(res => {
      //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
      //   const a = document.createElement('a')
      //   // 生成文件路径
      //   let href = window.URL.createObjectURL(blob)
      //   a.href = href
      //   let fileName = Y + M + D + h + m + s + ms + '_师傅账单'
      //   // 文件名中有中文 则对文件名进行转码
      //   a.download = decodeURIComponent(fileName)
      //   // 利用a标签做下载
      //   document.body.appendChild(a)
      //   a.click()
      //   document.body.removeChild(a)
      //   window.URL.revokeObjectURL(href)
      // })
    },
    // 确定生成对账单时时调用的方法
    EnterpriseOk() {
      this.generateible = false
      // this.Enterprisevisible = false;
      let obj = {
        orderNum: this.reslist.orderNum,
        statementNum: this.reslist.statementNum,
        subStatementDtos: this.DataList,
      }
      getenterGenerateState(obj).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.$router.push({ name: 'MasterStatementList' })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    EnterpriseStatementConfirm() {
      if (this.DataList) {
        this.loading = true
        if (this.DataList.length > 0) {
          // this.Enterprisevisible=true
          this.generateible = false
          // this.Enterprisevisible = false;
          let obj = {
            orderNum: this.reslist.orderNum,
            statementNum: this.reslist.statementNum,
            subStatementDtos: this.DataList,
          }
          getenterGenerateState(obj).then((res) => {
            if (res.code === 0) {
              // console.log(res)
              this.loading = false
              this.$router.push({ name: 'MasterStatementList' })
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('无账单可生成')
        }
      } else {
        this.$message.error('无账单可生成')
      }
    },
    clicInformationModal() {
      this.informationible = false
    },
    // 移除
    remove(record) {
      this.removeible = true
      this.orderid.push(record.masterId)
    },
    // 移除取消时调用的方法
    confirmCancel() {
      this.removeible = false
      this.orderid = []
    },
    // 移除确定时调用的方法
    confirmOk() {
      this.removeible = false
      this.DataList = this.DataList.filter((item) => !this.orderid.includes(item.masterId))
      this.Toptitle = '本次选择' + this.reslist.orderNum + '个订单，共生成' + this.reslist.statementNum + '个对账单：'
    },
    remarkList(record) {
      this.form.resetFields()
      this.remarkrows = []
      this.remarkrecord = ''
      this.recordorderId = ''
      if (record.masterId) {
        this.remarkible = true
        this.remarkrecord = record
      } else {
        this.remarkgenerateible = true
        this.recordorderId = record.orderId
        getremarkList({ billRemarkType: 1, orderId: record.orderId }).then((res) => {
          if (res.code === 0) {
            this.remarkrows = res.rows
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    billingView(record) {
      this.billingrecord = record
      this.informationible = true
      getSourceList({ orderIds: record.orderIds.join(',') }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.billinglist = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    goEnterpriseBill() {
      this.generateible = false
    },
    // 取消时调用的方法
    handleCancel() {
      // this.Enterprisevisible = false;
      this.generateible = false
      // this.$router.push({name:'EnterpriseBill'})
    },
    remarkconfirmOk() {
      this.remarkible = false
      this.remarkgenerateible = false
      if (this.recordorderId) {
        this.form.validateFields((err, values) => {
          values.billRemarkType = 2
          values.orderId = this.recordorderId
          if (!err) {
            saveremarkList(values).then((res) => {
              if (res.code === 0) {
                this.$refs.table.refresh()
                this.$message.success('操作成功')
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        })
      } else {
        let Sub = this.reslist.subStatementDtos.indexOf(this.remarkrecord)
        // console.log(Sub);
        if (Sub !== -1) {
          //当没有多余tab时就不再删除
          this.reslist.subStatementDtos[Sub].remark = this.form.getFieldValue('remark')
        }
      }
    },

    orderdetailsView(orderId) {
      this.$nextTick(() => {
        this.$refs.editorder.showeditOrder(orderId, '', 0)
      })
    },
    orderNodetailsView(orderId) {
      this.$nextTick(() => {
        this.$refs.associatedorder.showeditOrder(orderId, '', 0)
      })
    },
    onChangecreateOrde(date, dateString) {
      this.queryParam.createTimeBegin = dateString[0]
      this.queryParam.createTimeEnd = dateString[1]
    },
    onChangecompleteOrder(date, dateString) {
      this.queryParam.orderFinishTimeBegin = dateString[0]
      this.queryParam.orderFinishTimeEnd = dateString[1]
    },
    // 市
    getselect(e) {
      console.log(e)
      getselectCityName({ provinceCode: e }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 区
    getprovinceName(e) {
      getselectAreaName({ cityCode: e }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    async installChange(e) {
      this.queryParam.orderType = ''
      this.List = []
      await getList(e).then((res) => {
        if (res.code === 0) {
          this.List = res.rows
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    // 点按钮生成对账单
    async gocustGeneratestate() {
      if (this.$refs.table.localDataSource.length > 0) {
        this.orderIdArr = []
        // 有选中的值传id
        if (this.selectedRowKeys.length > 0) {
          this.selectedRow.forEach((item) => {
            return this.orderIdArr.push(item.orderId)
          })
          // console.log(this.orderIdArr)
          await getEnterpriseList({ isAll: 0, orderIds: this.orderIdArr }).then((res) => {
            if (res.code === 0) {
              this.generateible = true
              this.reslist = res.data
              this.DataList = this.reslist.subStatementDtos
              this.Toptitle = '本次选择' + res.data.orderNum + '个订单，共生成' + res.data.statementNum + '个对账单：'
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          // 没有选中的值传筛选信息
          await getEnterpriseList({ isAll: 1, searchParam: this.queryParam }).then((res) => {
            if (res.code === 0) {
              this.generateible = true
              this.reslist = res.data
              this.DataList = this.reslist.subStatementDtos
              this.Toptitle = '本次选择' + res.data.orderNum + '个订单，共生成' + res.data.statementNum + '个对账单：'
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      } else {
        this.$message.error('无账单生成')
      }
    },
    // 点操作栏生成对账单
    async goEnterpriseOne(record) {
      this.orderIdArr = []
      this.orderIdArr.push(record.orderId)
      await getEnterpriseList({ isAll: 0, orderIds: this.orderIdArr }).then((res) => {
        if (res.code === 0) {
          this.Toptitle = '本次选择' + res.data.orderNum + '个订单，共生成' + res.data.statementNum + '个对账单：'
          // // 响应的数据
          this.reslist = res.data
          this.DataList = this.reslist.subStatementDtos

          this.generateible = true
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 把复选框的索引和数据保存
    onSelectChange(selectedRowKeys, selectedRow) {
      this.selectedRow = selectedRow
      console.log(this.selectedRow)
      this.selectedRowKeys = selectedRowKeys
    },
    // 更多、隐藏
    getMore() {
      this.Ifstatus = 1
    },
    hiddenMore() {
      this.Ifstatus = 0
    },
    // 确认收款
    ConfirmReceipt(record) {
      this.$refs.modal.confirmReceipt(record.orderId)
    },
    // 退款
    confirmRefund(record) {
      this.$refs.modal.confirmRefund(record.orderId)
    },
    // 备注
    handleremark(record) {
      this.$refs.modal.remark(record.remark)
    },
  },
  watch: {},
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}

/deep/ .ant-table td {
  padding: 4px 16px;
}
</style>